export default __webpack_public_path__ + "static/media/SOUTH_KOREA.1df7bc63.png";